<template>
  <br />
  <p>
      <i>                               
          NB: Some reports contain additional information that may not be visible on the screen. To view the full data, please download the report (See arrow for download.)
      </i>
  </p>
</template>